import IssueClustersAPI from 'dashboard/api/issueClusters';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isMerging: false,
    isSplitting: false,
  },
  meta: {
    count: 0,
    currentPage: 1,
  },
};

export const getters = {
  getIssueClusters: $state => $state.records,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
  getIssueCluster: $state => id =>
    $state.records.find(cluster => cluster.id === Number(id)),
};

export const actions = {
  async fetch({ commit }, params = {}) {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await IssueClustersAPI.get(params);
      commit('set', response.data.payload);
      commit('setMeta', response.data.meta);
      return response.data;
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },

  async show({ commit }, id) {
    commit('setUIFlag', { isFetchingItem: true });
    try {
      const response = await IssueClustersAPI.show(id);
      commit('upsert', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isFetchingItem: false });
    }
  },

  async merge({ commit }, { id, sourceIds }) {
    commit('setUIFlag', { isMerging: true });
    try {
      const response = await IssueClustersAPI.merge(id, sourceIds);
      commit('upsert', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isMerging: false });
    }
  },

  async split({ commit }, { id, ticketIds }) {
    commit('setUIFlag', { isSplitting: true });
    try {
      const response = await IssueClustersAPI.split(id, ticketIds);
      commit('upsert', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isSplitting: false });
    }
  },
};

export const mutations = {
  setUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  set($state, records) {
    $state.records = records || [];
  },
  setMeta($state, meta = {}) {
    $state.meta = {
      count: meta.count || 0,
      currentPage: meta.current_page || 1,
    };
  },
  upsert($state, record) {
    if (!record || !record.id) return;
    const index = $state.records.findIndex(cluster => cluster.id === record.id);
    if (index === -1) {
      $state.records = [record, ...$state.records];
    } else {
      const next = [...$state.records];
      next[index] = record;
      $state.records = next;
    }
  },
  remove($state, id) {
    $state.records = $state.records.filter(cluster => cluster.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
